'use client';

export default function Spinner({ size = 14, className = '' }: { size?: number; className?: string }) {
  const bw = size <= 12 ? 1.5 : size <= 20 ? 2 : 2.5;
  return (
    <span
      className={`inline-block rounded-full border-current border-t-transparent animate-spin flex-shrink-0 ${className}`}
      style={{ width: size, height: size, borderWidth: bw }}
      aria-label="Loading"
    />
  );
}
